import axios from "axios";
import { encode as base64_encode } from "base-64";
import React from "react";
import HeaderPage from "../../components/PageHeader/PageHeader";
import StepCounter from "../../components/StepCounter/StepCounter";
import Loader from "../../components/Loader/Loader";
import { retornarCookie } from "../../services/cookieservice";
import {
  listarReembolsosDisponiveis,
  listarReembolsosOportunidade,
  adicionarReembolso,
  atualizarReembolso,
} from "../../services/nivel2service";
import "../../index.css";
import "./ReembolsoNivel2Page.css";

const { REACT_APP_API, REACT_APP_URL_INSTANCE } = process.env;

export default class ReembolsoNivel2Page extends React.Component {
  state = {
    oportunidade: undefined,
    elegibilidades: [],
    planosDistintos: [],
    reembolsosDisponiveisPorPlano: {},
    listaReembolsosRegistrados: [],
    formValues: {},
    formInputValues: {},
    erros: {},
    exibeCarregamento: true,
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const oportunidadeId = urlParams.get("OportunidadeID");

    this.carregarDados(oportunidadeId);
  }

  getOportunidadeId = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("OportunidadeID");
  };

  getStepData = () => {
    if (retornarCookie("Filial") === "3") {
      return { step: "4", total: "5" };
    }

    return { step: "4", total: "6" };
  };

  extrairScorePlano = (plano) => {
    const scoreRaw =
      plano?.Score ??
      plano?.score ??
      plano?.PlanoScore ??
      plano?.planoScore ??
      plano?.rpy_score;

    const score = parseFloat(scoreRaw);
    return Number.isNaN(score) ? undefined : score;
  };

  isGuid = (value) =>
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      String(value || "")
    );

  extrairPlanoId = (plano) => {
    const candidatos = [
      plano?.Id,
      plano?.id,
      plano?.PlanoId,
      plano?.planoId,
      plano?.PlanoCrmId,
      plano?.planoCrmId,
      plano?.IDPlano,
    ]
      .filter((item) => item !== undefined && item !== null && String(item).trim() !== "")
      .map((item) => String(item).trim());

    const guid = candidatos.find((item) => this.isGuid(item));
    return guid || candidatos[0] || "";
  };

  toDecimalNumber = (value) => {
    const numero = Number(value);
    if (Number.isNaN(numero)) {
      return undefined;
    }

    return Number(numero.toFixed(2));
  };

  formatarMoedaBR = (value) => {
    const numero = this.toDecimalNumber(value);
    if (numero === undefined) {
      return "";
    }

    return numero.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  aplicarMascaraMoeda = (value) => {
    const digitos = String(value || "").replace(/\D/g, "");
    if (!digitos) {
      return "";
    }

    return this.formatarMoedaBR(Number(digitos) / 100);
  };

  parseMoedaBR = (value) => {
    const digitos = String(value || "").replace(/\D/g, "");
    if (!digitos) {
      return undefined;
    }

    return this.toDecimalNumber(Number(digitos) / 100);
  };

  getEventoLimites = (evento) => ({
    minimo: this.toDecimalNumber(evento?.Minimo ?? evento?.minimo ?? 0) ?? 0,
    maximo:
      this.toDecimalNumber(evento?.Maximo ?? evento?.maximo ?? Number.MAX_SAFE_INTEGER) ??
      Number.MAX_SAFE_INTEGER,
  });

  validarValorEvento = (planoId, eventoId, valor, formValuesAtualizados) => {
    if (valor === undefined || valor === null || Number.isNaN(valor)) {
      return "Informe um valor válido.";
    }

    const evento = this.getEventoById(planoId, eventoId);
    const { minimo, maximo } = this.getEventoLimites(evento);

    if (valor < minimo || valor > maximo) {
      return `Valor deve estar entre R$ ${this.formatarMoedaBR(minimo)} e R$ ${this.formatarMoedaBR(maximo)}.`;
    }

    return this.validarHierarquiaReembolso(planoId, eventoId, valor, formValuesAtualizados);
  };

  validarFormulario = (formValuesAtualizados) => {
    const erros = {};

    (this.state.planosDistintos || []).forEach((plano) => {
      const eventos = this.state.reembolsosDisponiveisPorPlano[plano.planoId] || [];

      eventos.forEach((evento) => {
        const eventoId = evento.EventoReembolsoId || evento.eventoReembolsoId;
        const key = `${plano.planoId}_${eventoId}`;
        const erro = this.validarValorEvento(
          plano.planoId,
          eventoId,
          formValuesAtualizados[key],
          formValuesAtualizados
        );

        if (erro) {
          erros[key] = erro;
        }
      });
    });

    return erros;
  };

  validarHierarquiaReembolso = (planoId, eventoId, valorAtual, formValuesAtualizados) => {
    const planosComScore = (this.state.planosDistintos || [])
      .filter((p) => p.score !== undefined)
      .sort((a, b) => a.score - b.score);

    if (planosComScore.length <= 1) {
      return "";
    }

    const valoresPorPlano = planosComScore
      .map((plano) => {
        const key = `${plano.planoId}_${eventoId}`;
        const raw =
          String(plano.planoId) === String(planoId)
            ? valorAtual
            : formValuesAtualizados[key];

        if (raw === undefined || raw === null || raw === "") {
          return undefined;
        }

        const numero = parseFloat(raw);
        if (Number.isNaN(numero)) {
          return undefined;
        }

        return { score: plano.score, valor: numero };
      })
      .filter(Boolean);

    for (let i = 1; i < valoresPorPlano.length; i += 1) {
      if (valoresPorPlano[i].valor < valoresPorPlano[i - 1].valor) {
        return "Valor deve respeitar a hierarquia de planos por score.";
      }
    }

    return "";
  };

  carregarDados = async (oportunidadeId) => {
    this.setState({ exibeCarregamento: true });

    const params = {
      oportunidadeID: oportunidadeId,
      IdAgenteVendas: retornarCookie("IdAgenteVenda"),
      CdAgenteVendas: retornarCookie("CdAgenteVendas"),
      multiplasPropostas: false,
    };

    const paramsEleg = {
      oportunidadeID: oportunidadeId,
      IdAgenteVendas: retornarCookie("IdAgenteVenda"),
    };

    try {
      const [oportunidadeRes, elegibilidadesRes, reembolsosRegistrados] = await Promise.all([
        axios.get(`${REACT_APP_API}oportunidade/OportunidadePorId`, { params }),
        axios.get(`${REACT_APP_API}elegibilidade/elegibilidadesCompleta`, {
          params: paramsEleg,
        }),
        listarReembolsosOportunidade(oportunidadeId),
      ]);

      const oportunidade = oportunidadeRes.data;
      const elegibilidades = elegibilidadesRes.data || [];
      const listaReembolsosRegistrados = reembolsosRegistrados || [];

      const mapaPlanos = {};
      elegibilidades.forEach((eleg) => {
        (eleg.Planos || []).forEach((pl) => {
          const planoId = this.extrairPlanoId(pl);
          if (!planoId) {
            return;
          }

          const score = this.extrairScorePlano(pl);

          if (!mapaPlanos[planoId]) {
            mapaPlanos[planoId] = {
              planoId,
              planoNome: pl.NomePlano || pl.nomePlano || pl.DescricaoPlano || pl.descricaoPlano,
              score,
            };
          } else if (mapaPlanos[planoId].score === undefined && score !== undefined) {
            mapaPlanos[planoId].score = score;
          }
        });
      });

      const planosDistintos = Object.values(mapaPlanos);

      const resultadoDisponiveis = await Promise.all(
        planosDistintos.map(async (plano) => {
          const eventos = await listarReembolsosDisponiveis(plano.planoId);
          return { planoId: plano.planoId, eventos: eventos || [] };
        })
      );

      const reembolsosDisponiveisPorPlano = {};
      resultadoDisponiveis.forEach((item) => {
        reembolsosDisponiveisPorPlano[item.planoId] = item.eventos;
      });

      const formValues = {};
      const formInputValues = {};
      listaReembolsosRegistrados.forEach((reg) => {
        const plano = reg.PlanoCrmId || reg.planoCrmId || reg.PlanoId || reg.planoId;
        const evento =
          reg.EventoReembolsoCrmId || reg.eventoReembolsoCrmId || reg.EventoReembolsoId || reg.eventoReembolsoId;
        const key = `${plano}_${evento}`;
        const valor = this.toDecimalNumber(reg.Valor ?? reg.valor);
        formValues[key] = valor;
        formInputValues[key] = this.formatarMoedaBR(valor);
      });

      planosDistintos.forEach((plano) => {
        const eventos = reembolsosDisponiveisPorPlano[plano.planoId] || [];

        eventos.forEach((evento) => {
          const eventoId = evento.EventoReembolsoId || evento.eventoReembolsoId;
          const key = `${plano.planoId}_${eventoId}`;

          if (formValues[key] === undefined) {
            const valorPadrao = this.toDecimalNumber(evento.ValorPadrao ?? evento.valorPadrao ?? 0) ?? 0;
            formValues[key] = valorPadrao;
            formInputValues[key] = this.formatarMoedaBR(valorPadrao);
          } else if (formInputValues[key] === undefined) {
            formInputValues[key] = this.formatarMoedaBR(formValues[key]);
          }
        });
      });

      const erros = this.validarFormulario(formValues);

      this.setState({
        oportunidade,
        elegibilidades,
        planosDistintos,
        reembolsosDisponiveisPorPlano,
        listaReembolsosRegistrados,
        formValues,
        formInputValues,
        erros,
      });
    } catch (error) {
      alert("Erro ao carregar reembolsos do Nível 2.");
    } finally {
      this.setState({ exibeCarregamento: false });
    }
  };

  getEventoById = (planoId, eventoId) => {
    const eventos = this.state.reembolsosDisponiveisPorPlano[planoId] || [];
    return eventos.find(
      (ev) => (ev.EventoReembolsoId || ev.eventoReembolsoId) === eventoId
    );
  };

  handleReembolsoChange = (planoId, eventoId, value) => {
    const key = `${planoId}_${eventoId}`;
    const valorMascarado = this.aplicarMascaraMoeda(value);
    const numero = this.parseMoedaBR(valorMascarado);

    this.setState((prevState) => {
      const formValues = { ...prevState.formValues, [key]: numero };
      const formInputValues = { ...prevState.formInputValues, [key]: valorMascarado };
      const erros = { ...prevState.erros };

      if (erros[key]) {
        delete erros[key];
      }

      return { formValues, formInputValues, erros };
    });
  };

  handleReembolsoBlur = (planoId, eventoId) => {
    const key = `${planoId}_${eventoId}`;

    this.setState((prevState) => {
      const formValues = { ...prevState.formValues };
      const valor = prevState.formValues[key];
      const erros = { ...prevState.erros };
      const formInputValues = {
        ...prevState.formInputValues,
        [key]: valor === undefined ? "" : this.formatarMoedaBR(valor),
      };

      const erro = this.validarValorEvento(planoId, eventoId, valor, formValues);
      if (erro) {
        formValues[key] = undefined;
        formInputValues[key] = "";
        erros[key] = erro;
      } else {
        delete erros[key];
      }

      return { formValues, formInputValues, erros };
    });
  };

  continuar = async () => {
    const { formValues, listaReembolsosRegistrados } = this.state;
    const oportunidadeId = this.getOportunidadeId();
    const erros = this.validarFormulario(formValues);

    if (Object.keys(erros).length > 0) {
      this.setState((prevState) => {
        const formValues = { ...prevState.formValues };
        const formInputValues = { ...prevState.formInputValues };

        Object.keys(erros).forEach((key) => {
          formValues[key] = undefined;
          formInputValues[key] = "";
        });

        return { erros, formValues, formInputValues };
      });
      alert("Existem valores inválidos de reembolso.");
      return;
    }

    this.setState({ exibeCarregamento: true });

    try {
      const keys = Object.keys(formValues);

      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        const [planoId, eventoId] = key.split("_");
        const valor = this.toDecimalNumber(formValues[key]);

        if (valor === undefined) {
          // eslint-disable-next-line no-continue
          continue;
        }

        const existente = listaReembolsosRegistrados.find((reg) => {
          const plano = reg.PlanoCrmId || reg.planoCrmId || reg.PlanoId || reg.planoId;
          const evento =
            reg.EventoReembolsoCrmId || reg.eventoReembolsoCrmId || reg.EventoReembolsoId || reg.eventoReembolsoId;

          return String(plano) === String(planoId) && String(evento) === String(eventoId);
        });

        if (existente) {
          // eslint-disable-next-line no-await-in-loop
          await atualizarReembolso(
            oportunidadeId,
            existente.Id || existente.id,
            valor
          );
        } else {
          // eslint-disable-next-line no-await-in-loop
          await adicionarReembolso(oportunidadeId, {
            eventoReembolsoId: eventoId,
            planoId,
            valor,
          });
        }
      }

      const auth = `&Auth=${base64_encode(retornarCookie("Auth"))}`;
      const params = `&OportunidadeID=${oportunidadeId}`;

      if (retornarCookie("Filial") !== "3") {
        const redirectTo = `${REACT_APP_URL_INSTANCE}${base64_encode(
          "NavigationBar,InformacoesComplementaresPage"
        )}`;
        document.location.href = `${redirectTo}${auth}${params}`;
      } else {
        const redirectTo = `${REACT_APP_URL_INSTANCE}${base64_encode(
          "NavigationBar,GerarPropostaPage"
        )}`;
        document.location.href = `${redirectTo}${auth}${params}`;
      }
    } catch (error) {
      alert("Não foi possível salvar os reembolsos.");
      this.setState({ exibeCarregamento: false });
    }
  };

  voltar = () => {
    const oportunidadeId = this.getOportunidadeId();
    const redirectTo = `${REACT_APP_URL_INSTANCE}${base64_encode(
      "NavigationBar,ElegibilidadePage"
    )}`;
    const auth = `&Auth=${base64_encode(retornarCookie("Auth"))}`;
    const params = `&OportunidadeID=${oportunidadeId}`;

    document.location.href = `${redirectTo}${auth}${params}`;
  };

  renderEvento = (planoId, evento) => {
    const eventoId = evento.EventoReembolsoId || evento.eventoReembolsoId;
    const key = `${planoId}_${eventoId}`;

    const value =
      this.state.formInputValues[key] !== undefined
        ? this.state.formInputValues[key]
        : this.formatarMoedaBR(evento.ValorPadrao ?? evento.valorPadrao ?? 0);

    const { minimo, maximo } = this.getEventoLimites(evento);

    return (
      <tr className="reembolso-row" key={key}>
        <td>{evento.Nome || evento.nome}</td>
        <td>
          <input
            className="reembolso-valor-input"
            type="text"
            inputMode="numeric"
            value={value}
            onChange={(e) => this.handleReembolsoChange(planoId, eventoId, e.target.value)}
            onBlur={() => this.handleReembolsoBlur(planoId, eventoId)}
          />
          <div className="reembolso-limites">
            (mín: R$ {this.formatarMoedaBR(minimo)} / máx: R$ {this.formatarMoedaBR(maximo)})
          </div>
          {this.state.erros[key] && <div className="reembolso-error">{this.state.erros[key]}</div>}
        </td>
      </tr>
    );
  };

  render() {
    const { planosDistintos, reembolsosDisponiveisPorPlano } = this.state;
    const stepData = this.getStepData();

    return (
      <div className="fade-in">
        {this.state.exibeCarregamento && <Loader />}

        <div className="row container">
          <div className="col s9 m9 l9">
            <br />
            <b>
              <h5>Nova Oportunidade</h5>
            </b>
          </div>
          <div className="col s3 m3 l3">
            <br />
            <StepCounter step={stepData.step} total={stepData.total} />
          </div>
        </div>

        <div className="row container">
          <HeaderPage
            Spotlight="Reembolso"
            Title="Diferenciado"
            Description="Personalize os valores de reembolso por plano dentro dos limites configurados."
          />

          <div className="col s8 m8 l8">
            {planosDistintos.map((plano) => (
              <div key={plano.planoId} className="reembolso-card">
                <h5>{plano.planoNome}</h5>
                <table className="striped">
                  <thead>
                    <tr>
                      <th>Evento</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(reembolsosDisponiveisPorPlano[plano.planoId] || []).map((evento) =>
                      this.renderEvento(plano.planoId, evento)
                    )}
                  </tbody>
                </table>
              </div>
            ))}

            <div className="row">
              <div className="col s6">
                <button type="button" className="OmintButton" onClick={this.voltar}>
                  Voltar
                </button>
              </div>
              <div className="col s6 right-align">
                <button type="button" className="OmintButton" onClick={this.continuar}>
                  Continuar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
